import { render } from "./MainCreditNoteSale.vue?vue&type=template&id=da35ff50&scoped=true"
import script from "./MainCreditNoteSale.vue?vue&type=script&lang=js"
export * from "./MainCreditNoteSale.vue?vue&type=script&lang=js"

import "./MainCreditNoteSale.vue?vue&type=style&index=0&id=da35ff50&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da35ff50"]])

export default __exports__